"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// =================================================================================================
// COURSE MARK SHEETS (restricted course scenarios, e.g. ETC)
// -------------------------------------------------------------------------------------------------
// A restricted scenario may carry a `markScheme` block: the facilitator's pack for a course
// scenario (radio report, how to set the patient up, the A-B-C-D-E pathway with each role's
// findings and expected actions, the results to give, and the Achieved / Not achieved criteria).
// Nothing course-specific lives in this file: the content is read from the database at run time
// with the rest of the restricted scenario (see README "Restricted scenarios"), so this file only
// knows how to show it.
//
//   markScheme: {
//     kind: 'workshop' | 'assessment',        // assessment = pass needs every critical point
//     source, note,                            // where it came from; a caveat shown in amber
//     radioReport: [..], learningOutcomes: [..], technicalSkills: [..], nonTechnicalSkills: [..],
//     setup: { initial: [..], after: [..], afterLabel, equipment: [..], equipmentLabel, injuries: [..], skills: [..] },
//     pathway: [{ role, findings, actions }],  // findings/actions are multi-line strings
//     results: [{ label, text }],              // sounds, AMPLE, blood gases, X-rays, eFAST, CT
//     criticalPoints: [..], criticalNote,      // assessment scenarios
//     passRule: 'critical',                    // optional: only the critical points decide the verdict
//     verdictLabels: { pass, notYet },         // optional wording for the verdict badge
//     sectionLabels: { critical, technical, nonTechnical, other },   // optional section headings
//     kindLabel,                               // optional heading, e.g. 'CASTest (ALS assessment)'
//     pathwayHeadings: { role, findings, actions },                  // optional pathway columns
//     criteria: { technical: [..], nonTechnical: [..], other: [..] },   // the A / N items
//     summary, debriefPoints: [..], teachingPoints: [..],
//     media: [{ image, type, label, caption, slide }],   // course images: `image` is an id under
//     mediaNote                                         // courseImages/<course>/ (read at run time)
//   }
//
// Firebase stores arrays as objects with numeric keys (and drops empty ones), so every list is
// read through asList().
// =================================================================================================
(function () {
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect;
  var asList = function asList(v) {
    if (Array.isArray(v)) return v.filter(function (x) {
      return x !== null && x !== undefined && x !== '';
    });
    if (v && _typeof(v) === 'object') return Object.keys(v).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (k) {
      return v[k];
    }).filter(function (x) {
      return x !== null && x !== undefined && x !== '';
    });
    if (typeof v === 'string' && v.trim()) return [v];
    return [];
  };
  var str = function str(v) {
    return v === null || v === undefined ? '' : String(v);
  };
  var get = function get(scenario) {
    var ms = scenario && scenario.markScheme;
    return ms && _typeof(ms) === 'object' && !Array.isArray(ms) ? ms : null;
  };

  // The items a facilitator marks A (achieved) or N (not achieved), in order.
  var items = function items(scenario) {
    var ms = get(scenario);
    if (!ms) return [];
    var out = [];
    var crit = ms.criteria && _typeof(ms.criteria) === 'object' ? ms.criteria : {};
    asList(ms.criticalPoints).forEach(function (t, i) {
      return out.push({
        id: "cp".concat(i),
        section: 'critical',
        text: str(t)
      });
    });
    asList(crit.technical).forEach(function (t, i) {
      return out.push({
        id: "ts".concat(i),
        section: 'technical',
        text: str(t)
      });
    });
    asList(crit.nonTechnical).forEach(function (t, i) {
      return out.push({
        id: "nt".concat(i),
        section: 'nonTechnical',
        text: str(t)
      });
    });
    asList(crit.other).forEach(function (t, i) {
      return out.push({
        id: "ot".concat(i),
        section: 'other',
        text: str(t)
      });
    });
    return out;
  };
  var SECTION_LABEL = {
    critical: 'Critical points',
    technical: 'Technical skills',
    nonTechnical: 'Non-technical skills',
    other: 'Other criteria'
  };
  var sectionLabel = function sectionLabel(ms, s) {
    return str(ms && ms.sectionLabels && ms.sectionLabels[s]).trim() || SECTION_LABEL[s];
  };
  var kindLabel = function kindLabel(ms) {
    return str(ms && ms.kindLabel).trim() || (ms && ms.kind === 'assessment' ? 'Team leader assessment' : '');
  };

  // Overall result. An assessment passes only when every item is Achieved (both critical points
  // plus the other criteria); a workshop just counts. Nothing is decided until every item is marked.
  // With passRule 'critical' (e.g. the ALS CASTest, where every bold point must be achieved but a
  // missed non-bold point does not mean a re-test) only the critical points decide the verdict.
  var result = function result(scenario, marks) {
    var ms = get(scenario) || {};
    var list = items(scenario);
    var m = marks || {};
    var achieved = list.filter(function (i) {
      return m[i.id] === 'A';
    }).length;
    var notAchieved = list.filter(function (i) {
      return m[i.id] === 'N';
    }).length;
    var unmarked = list.length - achieved - notAchieved;
    var criticalMissed = list.filter(function (i) {
      return i.section === 'critical' && m[i.id] === 'N';
    }).length;
    var labels = ms.verdictLabels && _typeof(ms.verdictLabels) === 'object' ? ms.verdictLabels : {};
    var PASS = str(labels.pass).trim() || 'Pass',
      NOT_YET = str(labels.notYet).trim() || 'Not yet achieved';
    var verdict = null,
      passed = false;
    if (ms.kind === 'assessment' && list.length) {
      if (ms.passRule === 'critical') {
        var critical = list.filter(function (i) {
          return i.section === 'critical';
        });
        var criticalUnmarked = critical.filter(function (i) {
          return m[i.id] !== 'A' && m[i.id] !== 'N';
        }).length;
        if (criticalMissed) verdict = NOT_YET;else if (critical.length && !criticalUnmarked) {
          verdict = PASS;
          passed = true;
        }
      } else if (criticalMissed || notAchieved && !unmarked) verdict = NOT_YET;else if (!unmarked && !notAchieved) {
        verdict = PASS;
        passed = true;
      }
    }
    return {
      total: list.length,
      achieved: achieved,
      notAchieved: notAchieved,
      unmarked: unmarked,
      criticalMissed: criticalMissed,
      verdict: verdict,
      passed: passed
    };
  };

  // ---- display pieces ------------------------------------------------------------------------
  var Lines = function Lines(_ref) {
    var text = _ref.text,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
    var lines = str(text).split('\n').map(function (l) {
      return l.trimEnd();
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, lines.map(function (l, i) {
      return l.trim() ? /*#__PURE__*/React.createElement("div", {
        key: i
      }, l) : /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "h-1.5"
      });
    }));
  };
  var Bullets = function Bullets(_ref2) {
    var list = _ref2.list,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? 'text-slate-200' : _ref2$className;
    return /*#__PURE__*/React.createElement("ul", {
      className: "list-disc pl-5 space-y-0.5 text-sm ".concat(className)
    }, asList(list).map(function (t, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: i
      }, str(t));
    }));
  };
  var Block = function Block(_ref3) {
    var title = _ref3.title,
      _ref3$tone = _ref3.tone,
      tone = _ref3$tone === void 0 ? 'text-sky-400' : _ref3$tone,
      children = _ref3.children;
    return /*#__PURE__*/React.createElement("section", {
      className: "bg-slate-900/60 border border-slate-700 rounded-lg p-3 break-inside-avoid"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "text-xs font-bold uppercase tracking-wider mb-2 ".concat(tone)
    }, title), children);
  };

  // A / N marking row. `marks` absent = read-only.
  var MarkRow = function MarkRow(_ref4) {
    var item = _ref4.item,
      mark = _ref4.mark,
      onMark = _ref4.onMark;
    var btn = function btn(v, label, on) {
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-pressed": mark === v,
        "aria-label": "".concat(label, ": ").concat(item.text),
        onClick: function onClick() {
          return onMark(item.id, mark === v ? null : v);
        },
        className: "w-9 h-8 rounded border text-sm font-bold ".concat(mark === v ? on : 'border-slate-600 text-slate-400 hover:text-white')
      }, v);
    };
    return /*#__PURE__*/React.createElement("li", {
      className: "flex items-start gap-2 py-1 border-b border-slate-800 last:border-0"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex-1 text-sm ".concat(item.section === 'critical' ? 'text-amber-200 font-bold' : 'text-slate-200')
    }, item.text), onMark && /*#__PURE__*/React.createElement("span", {
      className: "flex gap-1 flex-none"
    }, btn('A', 'Achieved', 'bg-emerald-700 border-emerald-500 text-white'), btn('N', 'Not achieved', 'bg-red-800 border-red-500 text-white')));
  };
  var Criteria = function Criteria(_ref5) {
    var scenario = _ref5.scenario,
      marks = _ref5.marks,
      onMark = _ref5.onMark;
    var ms = get(scenario) || {};
    var list = items(scenario);
    if (!list.length) return null;
    var sections = ['critical', 'technical', 'nonTechnical', 'other'].filter(function (s) {
      return list.some(function (i) {
        return i.section === s;
      });
    });
    var r = result(scenario, marks);
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-3",
      "data-testid": "mark-criteria"
    }, onMark && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-3 text-xs text-slate-300"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", {
      className: "text-emerald-400"
    }, r.achieved), " achieved"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", {
      className: "text-red-400"
    }, r.notAchieved), " not achieved"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-200"
    }, r.unmarked), " not marked"), r.verdict && /*#__PURE__*/React.createElement("span", {
      "data-testid": "mark-verdict",
      className: "px-2 py-0.5 rounded font-bold uppercase ".concat(r.passed ? 'bg-emerald-800 text-emerald-100' : 'bg-red-900 text-red-100')
    }, r.verdict)), sections.map(function (s) {
      return /*#__PURE__*/React.createElement("div", {
        key: s
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[11px] font-bold uppercase tracking-wider mb-1 ".concat(s === 'critical' ? 'text-amber-400' : 'text-slate-400')
      }, sectionLabel(ms, s)), s === 'critical' && ms.criticalNote && /*#__PURE__*/React.createElement("p", {
        className: "text-[11px] text-amber-300/90 mb-1"
      }, str(ms.criticalNote)), /*#__PURE__*/React.createElement("ul", null, list.filter(function (i) {
        return i.section === s;
      }).map(function (i) {
        return /*#__PURE__*/React.createElement(MarkRow, {
          key: i.id,
          item: i,
          mark: marks ? marks[i.id] : undefined,
          onMark: onMark
        });
      })));
    }), onMark && /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-500"
    }, "Only two marks count: A (achieved) or N (not achieved). Press a mark again to clear it.", ms.kind === 'assessment' ? ms.passRule === 'critical' ? " The result above comes from the ".concat(sectionLabel(ms, 'critical').toLowerCase(), " only; the other items are recorded but do not decide it.") : ' An assessment is passed only when both critical points and the other criteria are achieved.' : ''));
  };

  // ---- course images (X-rays, CT, eFAST, scene photos from the course slides) -----------------
  // Read from the database only when a mark sheet is open, by an account entitled to the course.
  var courseKeyOf = function courseKeyOf(scenario) {
    return scenario && scenario.courseKey || (window.courseKeyFor ? window.courseKeyFor(scenario) : 'rcuk');
  };
  var media = function media(scenario) {
    return asList((get(scenario) || {}).media).filter(function (m) {
      return m && _typeof(m) === 'object' && typeof m.image === 'string' && m.image;
    });
  };
  var mediaKey = function mediaKey(item) {
    return "course:".concat(item.image);
  };
  var loadMedia = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(scenario, item) {
      var img, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!window.loadCourseImage) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return window.loadCourseImage(courseKeyOf(scenario), item.image);
          case 1:
            _t = _context.v;
            _context.n = 3;
            break;
          case 2:
            _t = null;
          case 3:
            img = _t;
            if (img && window.INVESTIGATIONS && window.INVESTIGATIONS.registerImage) window.INVESTIGATIONS.registerImage(mediaKey(item), img);
            return _context.a(2, img);
        }
      }, _callee);
    }));
    return function loadMedia(_x, _x2) {
      return _ref6.apply(this, arguments);
    };
  }();
  // Shows one image on the patient monitor. Monitors join with no account, so the image being
  // shown is copied to the session (sessions/<code>/courseImage) and removed when the run ends.
  var showOnMonitor = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref7) {
      var sim, sessionID, scenario, item, withReport, img, key, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            sim = _ref7.sim, sessionID = _ref7.sessionID, scenario = _ref7.scenario, item = _ref7.item, withReport = _ref7.withReport;
            _context2.n = 1;
            return loadMedia(scenario, item);
          case 1:
            img = _context2.v;
            if (!(!img || !sim || !sim.revealInvestigation)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, false);
          case 2:
            key = mediaKey(item);
            if (!(sessionID && window.db)) {
              _context2.n = 6;
              break;
            }
            _context2.p = 3;
            _context2.n = 4;
            return window.db.ref("sessions/".concat(sessionID, "/courseImage")).set({
              key: key,
              src: img.src,
              credit: str(img.credit).slice(0, 400),
              modality: str(img.modality).slice(0, 16),
              ts: Date.now()
            });
          case 4:
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            return _context2.a(2, false);
          case 6:
            sim.revealInvestigation(str(item.type) || 'Picture', item.caption ? str(item.caption) : null, {
              image: key,
              hideReport: !(withReport && item.caption)
            });
            return _context2.a(2, true);
        }
      }, _callee2, null, [[3, 5]]);
    }));
    return function showOnMonitor(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();
  var clearMonitorImage = function clearMonitorImage(sessionID) {
    if (sessionID && window.db) {
      try {
        window.db.ref("sessions/".concat(sessionID, "/courseImage")).remove();
      } catch (e) {}
    }
  };
  var MediaThumb = function MediaThumb(_ref9) {
    var scenario = _ref9.scenario,
      item = _ref9.item,
      onShow = _ref9.onShow,
      withReport = _ref9.withReport;
    var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      img = _useState2[0],
      setImg = _useState2[1];
    var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      sent = _useState4[0],
      setSent = _useState4[1];
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      big = _useState6[0],
      setBig = _useState6[1];
    useEffect(function () {
      var live = true;
      loadMedia(scenario, item).then(function (v) {
        if (live) setImg(v || null);
      });
      return function () {
        live = false;
      };
    }, [item.image]);
    return /*#__PURE__*/React.createElement("li", {
      className: "bg-slate-950/60 border border-slate-700 rounded p-2 flex gap-2 items-start",
      "data-testid": "mark-media-item"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return img && setBig(true);
      },
      className: "w-28 h-20 flex-none bg-black rounded overflow-hidden flex items-center justify-center",
      "aria-label": "Enlarge ".concat(str(item.label))
    }, img ? /*#__PURE__*/React.createElement("img", {
      src: img.src,
      alt: str(item.label),
      className: "max-w-full max-h-full object-contain"
    }) : /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-500 px-1 text-center"
    }, img === null ? 'Image not available' : 'Loading…')), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0 flex-1 text-xs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold text-slate-100"
    }, str(item.label) || str(item.type)), item.caption && /*#__PURE__*/React.createElement("div", {
      className: "text-slate-300 leading-snug"
    }, str(item.caption)), img && img.credit && /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-500 mt-0.5 leading-tight"
    }, "Image: ", str(img.credit), "."), onShow && img && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t3, _t4;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _t3 = setSent;
              _context3.n = 1;
              return onShow(item, withReport);
            case 1:
              if (!_context3.v) {
                _context3.n = 2;
                break;
              }
              _t4 = 'ok';
              _context3.n = 3;
              break;
            case 2:
              _t4 = 'fail';
            case 3:
              return _context3.a(2, _t3(_t4));
          }
        }, _callee3);
      })),
      className: "mt-1 px-2 py-1 rounded border border-purple-500/70 text-purple-200 hover:bg-purple-900/40 text-[11px] font-bold"
    }, "Show on monitor"), sent === 'ok' && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 text-[10px] text-emerald-300"
    }, "Sent"), sent === 'fail' && /*#__PURE__*/React.createElement("span", {
      className: "ml-2 text-[10px] text-red-300"
    }, "Could not send")), big && img && /*#__PURE__*/React.createElement("div", {
      role: "dialog",
      "aria-label": "Image: ".concat(str(item.label)),
      className: "fixed inset-0 z-[90] bg-black/95 flex flex-col items-center justify-center p-3",
      onClick: function onClick() {
        return setBig(false);
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: img.src,
      alt: str(item.label),
      className: "max-w-full max-h-[86vh] object-contain"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 mt-2"
    }, "Tap to close. Image: ", str(img.credit), ".")));
  };
  var MediaBlock = function MediaBlock(_ref1) {
    var scenario = _ref1.scenario,
      onShowImage = _ref1.onShowImage,
      onClearImage = _ref1.onClearImage;
    var list = media(scenario);
    var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      withReport = _useState8[0],
      setWithReport = _useState8[1];
    if (!list.length) return null;
    var ms = get(scenario) || {};
    return /*#__PURE__*/React.createElement(Block, {
      title: "Images",
      tone: "text-purple-300"
    }, /*#__PURE__*/React.createElement("div", {
      "data-testid": "mark-media"
    }, ms.mediaNote && /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-slate-400 mb-2"
    }, str(ms.mediaNote)), onShowImage && /*#__PURE__*/React.createElement("label", {
      className: "flex items-center gap-2 text-[11px] text-slate-300 mb-2 cursor-pointer"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: withReport,
      onChange: function onChange(e) {
        return setWithReport(e.target.checked);
      }
    }), "Show the written finding with the image (untick to show the image alone)"), /*#__PURE__*/React.createElement("ul", {
      className: "grid sm:grid-cols-2 gap-2"
    }, list.map(function (m, i) {
      return /*#__PURE__*/React.createElement(MediaThumb, {
        key: "".concat(m.image, "-").concat(i),
        scenario: scenario,
        item: m,
        onShow: onShowImage,
        withReport: withReport
      });
    })), onClearImage && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onClearImage,
      "data-testid": "mark-media-clear",
      className: "mt-2 text-[11px] uppercase font-bold px-3 py-2 rounded border border-red-500 text-red-200 hover:bg-red-900/40"
    }, "Clear from the patient screens")));
  };

  // The whole facilitator pack. `marks`/`onMark` add A/N buttons to the criteria.
  var MarkSheetBody = function MarkSheetBody(_ref10) {
    var scenario = _ref10.scenario,
      marks = _ref10.marks,
      onMark = _ref10.onMark,
      onShowImage = _ref10.onShowImage,
      onClearImage = _ref10.onClearImage;
    var ms = get(scenario);
    if (!ms) return null;
    var setup = ms.setup && _typeof(ms.setup) === 'object' ? ms.setup : {};
    var pathway = asList(ms.pathway).filter(function (r) {
      return r && _typeof(r) === 'object';
    });
    var results = asList(ms.results).filter(function (r) {
      return r && _typeof(r) === 'object';
    });
    var ph = ms.pathwayHeadings && _typeof(ms.pathwayHeadings) === 'object' ? ms.pathwayHeadings : {};
    return /*#__PURE__*/React.createElement("div", {
      className: "space-y-3 text-left"
    }, ms.note && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-amber-300 bg-amber-950/30 border border-amber-700/50 rounded p-2"
    }, str(ms.note)), asList(ms.radioReport).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Scenario / radio report"
    }, /*#__PURE__*/React.createElement(Bullets, {
      list: ms.radioReport
    })), /*#__PURE__*/React.createElement("div", {
      className: "grid md:grid-cols-2 gap-3"
    }, asList(ms.learningOutcomes).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Learning outcomes",
      tone: "text-indigo-300"
    }, /*#__PURE__*/React.createElement(Bullets, {
      list: ms.learningOutcomes
    })), (asList(ms.technicalSkills).length > 0 || asList(ms.nonTechnicalSkills).length > 0) && /*#__PURE__*/React.createElement(Block, {
      title: "Skills",
      tone: "text-indigo-300"
    }, asList(ms.technicalSkills).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold"
    }, "Technical"), /*#__PURE__*/React.createElement(Bullets, {
      list: ms.technicalSkills
    })), asList(ms.nonTechnicalSkills).length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold mt-1"
    }, "Non-technical"), /*#__PURE__*/React.createElement(Bullets, {
      list: ms.nonTechnicalSkills
    })))), (asList(setup.initial).length > 0 || asList(setup.injuries).length > 0 || asList(setup.equipment).length > 0) && /*#__PURE__*/React.createElement(Block, {
      title: "Setting up the patient",
      tone: "text-emerald-400"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-3 text-sm"
    }, asList(setup.initial).length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold"
    }, "Initial obs"), /*#__PURE__*/React.createElement(Bullets, {
      list: setup.initial
    })), asList(setup.after).length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold"
    }, str(setup.afterLabel) || 'After treatment'), /*#__PURE__*/React.createElement(Bullets, {
      list: setup.after
    })), asList(setup.injuries).length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold"
    }, "Injuries (moulage)"), /*#__PURE__*/React.createElement(Bullets, {
      list: setup.injuries
    })), asList(setup.equipment).length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "text-[11px] text-slate-400 uppercase font-bold"
    }, str(setup.equipmentLabel) || 'On arrival'), /*#__PURE__*/React.createElement(Bullets, {
      list: setup.equipment
    }))), asList(setup.skills).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mt-2 text-xs text-slate-400"
    }, /*#__PURE__*/React.createElement("b", {
      className: "text-slate-300"
    }, "Skills stations:"), " ", asList(setup.skills).join('; '))), pathway.length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Pathway: findings to give and expected actions",
      tone: "text-amber-400"
    }, /*#__PURE__*/React.createElement("div", {
      className: "overflow-x-auto"
    }, /*#__PURE__*/React.createElement("table", {
      className: "w-full text-sm border-collapse",
      "data-testid": "mark-pathway"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
      className: "text-[11px] uppercase text-slate-400"
    }, /*#__PURE__*/React.createElement("th", {
      className: "text-left p-1 w-16"
    }, str(ph.role) || 'Role'), /*#__PURE__*/React.createElement("th", {
      className: "text-left p-1"
    }, str(ph.findings) || 'Findings (role card)'), /*#__PURE__*/React.createElement("th", {
      className: "text-left p-1"
    }, str(ph.actions) || 'Expected actions'))), /*#__PURE__*/React.createElement("tbody", null, pathway.map(function (r, i) {
      return /*#__PURE__*/React.createElement("tr", {
        key: i,
        className: "align-top border-t border-slate-700"
      }, /*#__PURE__*/React.createElement("td", {
        className: "p-1 font-bold text-white whitespace-pre-line"
      }, str(r.role)), /*#__PURE__*/React.createElement("td", {
        className: "p-1 text-slate-200"
      }, /*#__PURE__*/React.createElement(Lines, {
        text: r.findings
      })), /*#__PURE__*/React.createElement("td", {
        className: "p-1 text-emerald-200"
      }, /*#__PURE__*/React.createElement(Lines, {
        text: r.actions
      })));
    }))))), results.length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Results to give when asked",
      tone: "text-cyan-300"
    }, /*#__PURE__*/React.createElement("dl", {
      className: "grid sm:grid-cols-2 gap-x-4 gap-y-1 text-sm"
    }, results.map(function (r, i) {
      return /*#__PURE__*/React.createElement("div", {
        key: i,
        className: "flex gap-2"
      }, /*#__PURE__*/React.createElement("dt", {
        className: "text-slate-400 font-bold min-w-[7rem]"
      }, str(r.label)), /*#__PURE__*/React.createElement("dd", {
        className: "text-slate-200 whitespace-pre-line"
      }, str(r.text)));
    }))), /*#__PURE__*/React.createElement(MediaBlock, {
      scenario: scenario,
      onShowImage: onShowImage,
      onClearImage: onClearImage
    }), items(scenario).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: onMark ? 'Mark sheet' : 'Mark scheme',
      tone: "text-fuchsia-300"
    }, /*#__PURE__*/React.createElement(Criteria, {
      scenario: scenario,
      marks: marks,
      onMark: onMark
    })), (ms.summary || asList(ms.debriefPoints).length > 0) && /*#__PURE__*/React.createElement(Block, {
      title: "Debrief: learning points",
      tone: "text-violet-300"
    }, ms.summary && /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-300 mb-1"
    }, str(ms.summary)), /*#__PURE__*/React.createElement(Bullets, {
      list: ms.debriefPoints
    })), asList(ms.teachingPoints).length > 0 && /*#__PURE__*/React.createElement(Block, {
      title: "Teaching aid",
      tone: "text-slate-300"
    }, /*#__PURE__*/React.createElement(Bullets, {
      list: ms.teachingPoints,
      className: "text-slate-300"
    })), ms.source && /*#__PURE__*/React.createElement("p", {
      className: "text-[10px] text-slate-500"
    }, "Source: ", str(ms.source)));
  };

  // ---- printable HTML (the mark sheet on its own, or inside the debrief report) ----------------
  var esc = function esc(value) {
    return String(value !== null && value !== void 0 ? value : '').replace(/[&<>'"]/g, function (c) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[c];
    });
  };
  var ul = function ul(list) {
    return asList(list).length ? "<ul>".concat(asList(list).map(function (t) {
      return "<li>".concat(esc(t), "</li>");
    }).join(''), "</ul>") : '';
  };
  var nl = function nl(t) {
    return esc(t).replace(/\n/g, '<br>');
  };
  var criteriaHtml = function criteriaHtml(scenario, marks) {
    var ms = get(scenario) || {};
    var list = items(scenario);
    if (!list.length) return '';
    var r = result(scenario, marks);
    var rows = list.map(function (i) {
      var m = marks ? marks[i.id] : null;
      var cell = marks ? "<td style=\"width:70px;font-weight:bold;color:".concat(m === 'A' ? '#15803d' : m === 'N' ? '#b91c1c' : '#64748b', "\">").concat(m === 'A' ? 'A' : m === 'N' ? 'N' : '&ndash;', "</td>") : '<td style="width:90px;">A &nbsp;/&nbsp; N</td>';
      return "<tr><td style=\"width:150px;color:#475569;\">".concat(esc(sectionLabel(ms, i.section)), "</td><td").concat(i.section === 'critical' ? ' style="font-weight:bold;"' : '', ">").concat(esc(i.text), "</td>").concat(cell, "</tr>");
    }).join('');
    var summary = marks ? "<p><b>".concat(r.achieved, "</b> achieved, <b>").concat(r.notAchieved, "</b> not achieved, <b>").concat(r.unmarked, "</b> not marked").concat(r.verdict ? " &middot; <b>".concat(esc(r.verdict), "</b>") : '', ".</p>") : '';
    return "".concat(ms.criticalNote ? "<p style=\"color:#92400e;\">".concat(esc(ms.criticalNote), "</p>") : '').concat(summary, "<table><thead><tr><th>Section</th><th>Criterion</th><th>Mark</th></tr></thead><tbody>").concat(rows, "</tbody></table>");
  };
  var sheetHtml = function sheetHtml(scenario, marks) {
    var ms = get(scenario);
    if (!ms) return '';
    var setup = ms.setup && _typeof(ms.setup) === 'object' ? ms.setup : {};
    var pathway = asList(ms.pathway).filter(function (r) {
      return r && _typeof(r) === 'object';
    });
    var results = asList(ms.results).filter(function (r) {
      return r && _typeof(r) === 'object';
    });
    var ph = ms.pathwayHeadings && _typeof(ms.pathwayHeadings) === 'object' ? ms.pathwayHeadings : {};
    var card = function card(title, body) {
      return body ? "<div class=\"card\"><h3>".concat(esc(title), "</h3>").concat(body, "</div>") : '';
    };
    return [ms.note ? "<p style=\"color:#92400e;border:1px solid #f59e0b;padding:6px;border-radius:6px;\">".concat(esc(ms.note), "</p>") : '', card('Scenario / radio report', ul(ms.radioReport)), card('Learning outcomes', ul(ms.learningOutcomes)), card('Skills', (asList(ms.technicalSkills).length ? "<h4>Technical</h4>".concat(ul(ms.technicalSkills)) : '') + (asList(ms.nonTechnicalSkills).length ? "<h4>Non-technical</h4>".concat(ul(ms.nonTechnicalSkills)) : '')), card('Setting up the patient', (asList(setup.initial).length ? "<h4>Initial obs</h4>".concat(ul(setup.initial)) : '') + (asList(setup.after).length ? "<h4>".concat(esc(setup.afterLabel || 'After treatment'), "</h4>").concat(ul(setup.after)) : '') + (asList(setup.injuries).length ? "<h4>Injuries (moulage)</h4>".concat(ul(setup.injuries)) : '') + (asList(setup.equipment).length ? "<h4>".concat(esc(setup.equipmentLabel || 'On arrival'), "</h4>").concat(ul(setup.equipment)) : '') + (asList(setup.skills).length ? "<h4>Skills stations</h4>".concat(ul(setup.skills)) : '')), card('Pathway: findings to give and expected actions', pathway.length ? "<table><thead><tr><th>".concat(esc(ph.role || 'Role'), "</th><th>").concat(esc(ph.findings || 'Findings (role card)'), "</th><th>").concat(esc(ph.actions || 'Expected actions'), "</th></tr></thead><tbody>").concat(pathway.map(function (r) {
      return "<tr><td><b>".concat(nl(r.role), "</b></td><td>").concat(nl(r.findings), "</td><td>").concat(nl(r.actions), "</td></tr>");
    }).join(''), "</tbody></table>") : ''), card('Results to give when asked', results.length ? "<table><tbody>".concat(results.map(function (r) {
      return "<tr><td style=\"width:160px;\"><b>".concat(esc(r.label), "</b></td><td>").concat(nl(r.text), "</td></tr>");
    }).join(''), "</tbody></table>") : ''), card(marks ? 'Mark sheet' : 'Mark scheme', criteriaHtml(scenario, marks)), card('Debrief: learning points', (ms.summary ? "<p>".concat(esc(ms.summary), "</p>") : '') + ul(ms.debriefPoints)), card('Teaching aid', ul(ms.teachingPoints)), ms.source ? "<p class=\"muted\">Source: ".concat(esc(ms.source), "</p>") : ''].join('');
  };
  var printSheet = function printSheet(scenario) {
    var css = 'body{font-family:Arial,sans-serif;color:#0f172a;margin:0;padding:20px;max-width:1000px}h1{color:#0369a1;margin:0 0 4px}h3{margin:0 0 6px}h4{margin:8px 0 4px;color:#334155}.card{border:1px solid #cbd5e1;border-radius:8px;padding:10px 12px;margin-bottom:10px;break-inside:avoid}table{width:100%;border-collapse:collapse;font-size:.85rem}th,td{text-align:left;vertical-align:top;padding:4px 6px;border-bottom:1px solid #e2e8f0}th{color:#475569;font-size:.7rem;text-transform:uppercase}ul{margin:0;padding-left:20px}.muted{color:#64748b;font-size:.75rem}.restricted{color:#92400e;font-size:.75rem}';
    var html = "<!DOCTYPE html><html lang=\"en-GB\"><head><meta charset=\"UTF-8\"><title>Mark sheet \u2014 ".concat(esc(scenario.title), "</title><style>").concat(css, "</style></head><body><h1>").concat(esc(scenario.title), "</h1><p class=\"restricted\">Restricted course material. For use on the course only; do not copy or share.</p>").concat(sheetHtml(scenario, null), "</body></html>");
    var w = window.open('', '_blank');
    if (!w || !w.document) {
      window.alert('The browser blocked the print window. Allow pop-ups for this site and try again.');
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
    var go = function go() {
      try {
        w.focus();
        w.print();
      } catch (e) {}
    };
    if (w.document.readyState === 'complete') setTimeout(go, 300);else w.addEventListener('load', function () {
      return setTimeout(go, 300);
    });
  };

  // ---- the modal (scenario list, briefing and controller) --------------------------------------
  // `onShowImage(item, withReport)` (controller only) adds Show on monitor to each course image.
  var MarkSheetModal = function MarkSheetModal(_ref11) {
    var scenario = _ref11.scenario,
      onClose = _ref11.onClose,
      onShowImage = _ref11.onShowImage,
      onClearImage = _ref11.onClearImage;
    var _window = window,
      Modal = _window.Modal,
      Button = _window.Button,
      Lucide = _window.Lucide;
    if (!scenario || !get(scenario)) return null;
    return /*#__PURE__*/React.createElement(Modal, {
      fixed: true,
      label: "Mark sheet: ".concat(scenario.title),
      onClose: onClose,
      className: "bg-slate-800 border border-slate-600 rounded-lg w-full max-w-5xl max-h-[92vh] flex flex-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between gap-2 p-3 border-b border-slate-700"
    }, /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-wider text-amber-400 font-bold"
    }, kindLabel(get(scenario)) || 'Facilitator pack', scenario.group ? " \xB7 ".concat(scenario.group) : ''), /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white truncate"
    }, scenario.title)), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 flex-none"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return printSheet(scenario);
      },
      className: "h-8 px-2 text-xs"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "printer",
      className: "w-3 h-3 mr-1"
    }), " Print"), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onClose,
      className: "h-8 px-3 text-xs"
    }, "Close"))), /*#__PURE__*/React.createElement("div", {
      className: "overflow-y-auto p-3"
    }, /*#__PURE__*/React.createElement(MarkSheetBody, {
      scenario: scenario,
      onShowImage: onShowImage,
      onClearImage: onClearImage
    })));
  };

  // ---- the debrief card ------------------------------------------------------------------------
  var DebriefMarkSheet = function DebriefMarkSheet(_ref12) {
    var scenario = _ref12.scenario,
      marks = _ref12.marks,
      onMark = _ref12.onMark;
    var _useState9 = useState(false),
      _useState0 = _slicedToArray(_useState9, 2),
      open = _useState0[0],
      setOpen = _useState0[1];
    var ms = get(scenario);
    if (!ms || !items(scenario).length) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-4 rounded-lg border border-fuchsia-800/60",
      "data-testid": "debrief-marksheet"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white mb-1"
    }, kindLabel(ms) || 'Mark sheet'), /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-400 mb-2"
    }, "Mark each criterion for the team leader. The marks go into the downloaded or printed report."), /*#__PURE__*/React.createElement(Criteria, {
      scenario: scenario,
      marks: marks,
      onMark: onMark
    }), (ms.summary || asList(ms.debriefPoints).length > 0) && /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setOpen(function (o) {
          return !o;
        });
      },
      className: "text-xs text-sky-300 underline"
    }, open ? 'Hide' : 'Show', " the learning points for the debrief"), open && /*#__PURE__*/React.createElement("div", {
      className: "mt-2"
    }, ms.summary && /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-slate-300 mb-1"
    }, str(ms.summary)), /*#__PURE__*/React.createElement(Bullets, {
      list: ms.debriefPoints
    }))));
  };

  // Groups restricted scenarios for the list: course, then group, in authored order.
  var groupScenarios = function groupScenarios(list) {
    var order = function order(s) {
      return Number.isFinite(Number(s.order)) ? Number(s.order) : 1e6;
    };
    var sorted = _toConsumableArray(list).sort(function (a, b) {
      return order(a) - order(b) || str(a.title).localeCompare(str(b.title));
    });
    var groups = [];
    sorted.forEach(function (s) {
      var key = str(s.group) || str(s.category) || 'Other';
      var g = groups.find(function (x) {
        return x.key === key;
      });
      if (!g) {
        g = {
          key: key,
          scenarios: []
        };
        groups.push(g);
      }
      g.scenarios.push(s);
    });
    return groups;
  };
  var courseOf = function courseOf(s) {
    return str(s && s.course).trim() || 'Other';
  };
  window.MarkScheme = {
    media: media,
    loadMedia: loadMedia,
    showOnMonitor: showOnMonitor,
    clearMonitorImage: clearMonitorImage,
    get: get,
    items: items,
    result: result,
    asList: asList,
    sheetHtml: sheetHtml,
    criteriaHtml: criteriaHtml,
    printSheet: printSheet,
    groupScenarios: groupScenarios,
    courseOf: courseOf,
    MarkSheetBody: MarkSheetBody,
    MarkSheetModal: MarkSheetModal,
    DebriefMarkSheet: DebriefMarkSheet
  };
})();